var map = {
	"./dark/alarm.png": 297,
	"./dark/alarmset.png": 2953,
	"./dark/category.png": 7220,
	"./dark/chart.png": 1878,
	"./dark/collapse.png": 253,
	"./dark/datareport.png": 8598,
	"./dark/druid.png": 9578,
	"./dark/home.png": 8205,
	"./dark/logo.png": 1929,
	"./dark/logodz.png": 1095,
	"./dark/open.png": 3164,
	"./dark/spjhgl.png": 8714,
	"./dark/ssjkkb.png": 2732,
	"./dark/system.png": 2912,
	"./light/alarm.png": 6153,
	"./light/alarmset.png": 2809,
	"./light/category.png": 9396,
	"./light/chart.png": 6022,
	"./light/collapse.png": 6813,
	"./light/datareport.png": 1238,
	"./light/druid.png": 666,
	"./light/home.png": 125,
	"./light/logo.png": 745,
	"./light/logodz.png": 4567,
	"./light/open.png": 3004,
	"./light/spjhgl.png": 474,
	"./light/ssjkkb.png": 6428,
	"./light/system.png": 8179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3013;